import { sendRequest } from '../../config';

export interface getMotivoAtencionParams {
    /** parametros obligatorios */
    cpais: string;

    /** parametros opcionales */
    ctipo?: string;
    xdescripcion?: string;
    iestado?: string;
    ipublicacion_canaldigital?: string;
}

export interface dataMotivoAtencion {
    ctipo?: string;
    u_version?: string;
    xdescripcion?: string;
    iestado?: string;
    fingreso?: string;
    bloqueado?: string;
    cerrado?: string;
    cusuario?: string;
    ccategoria?: string;
    cuusuarioauto?: string;
    ccategoriaauto?: string;
    fultmod?: string;
    cusuariomod?: string;
    ccategoriamod?: string;
    ipublicacion_canaldigital?: string;
    description?: string;
}

export const getMotivoAtencion = async (params: getMotivoAtencionParams): Promise<dataMotivoAtencion[]> => {
    const ENDPOINT = 'wstipoasistencia/get';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};